import React, { Component } from 'react';
import './style.scss';
import ltoJson from '../../../localdata/lto/lto.json';
import { Link } from 'react-router-dom';
import moment from 'moment-timezone';
import { trackGAEvent } from '../../../shared/helpers';
import arrow from '../../../assets/images/hero-arrow.png';
//const API_URL =  process.env.REACT_APP_API_URL;

class HeroLTO extends Component {
    
    state = {
        loaded: false,
        lto: false,
        region: false,
        preview: false,
        ltoJson: ltoJson
    }

    componentDidMount = () => {
         // Pass it a callback
         //loadDynamicGeoIp(this.getLocation);
        this.getLocation();
         // Check if 'QC' otherwise set the region to 'ROC' 

    }

    getLocation = () => {

        // Check for locale in LocalStorage..
        if(sessionStorage && sessionStorage.getItem('aw_locale')){

            let region =  sessionStorage.getItem("aw_locale");
            try {
                region =  JSON.parse(region); // Sometimes it's JSON encoded, sometimes it's not...
            } catch(e) {
                console.log("aw_locale was not encoded", region);
            }
            this.setState({
                region: region
            });
            //console.log('locale in storage ',region);

        }else{
            // Use geoip2 to grab region
            window.geoip2.insights(this.onSuccess, this.onError)
        }
         
    }

    onSuccess = (res) => {
        //console.log('loca success ', res.location.latitude);
        let position = {
            lat: parseFloat(res.location.latitude),
            lng: parseFloat(res.location.longitude)
        };
        let region = res.subdivisions[0].iso_code;
        let canadian = region.match(/^(AB|BC|MB|NB|NL|NS|NT|NU|ON|PE|QC|SK|YK)$/);

        if(canadian){
            // Set LocalStorage if available
            if(sessionStorage){
                sessionStorage.setItem('aw_locale', JSON.stringify(region));
                sessionStorage.setItem('aw_position', JSON.stringify(position));
            }
            // Set State
            this.setState({
                region: region
            });
        }else{
            //console.log('not a canadian region ');
            // Set Region to default - ON 
            if(sessionStorage){
                sessionStorage.setItem('aw_locale','ON');
            }

            this.setState({
                region: 'ON'
            });
        }
        
    }

    onError = () => {
        //console.log('error');
        // Set Region to default - ON 
        if(localStorage){
            localStorage.setItem('aw_locale','ON');
        }
        this.setState({
            region: 'ON'
        });
 
        // Default to Ontario - ON 
        // Default lat and lng to Toronto

        // var loc = { // Default to Toronto
        // 				lat: 43.653226,
        // 				lng: -79.3831843
        // 			};
        // 			this._region = "ON";  
            
    }
   


    // reminder to make sure LTO order leaves "ALL" as last in order

    findActiveLTO = () => {
         
        // let region = this.state.region == 'QC' ? 'QC' : 'ROC'; // Support both ROC and specific province codes BC
        // Figure out which LTO, if any, is active
        let matchedRegion = false; 
        let imgHeroLTO = this.state.ltoJson.map((lto, index) => {
            let timezone = lto.timezone;
            let startDate = moment.tz(lto.starts, timezone);
            let endDate = moment.tz(lto.expires, timezone);
            let now = moment();

            if (['awdev.rethinkcanada.ca', 'localhost'].includes(window.location.hostname)) {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                const od = urlParams.get('override_lto_date')
                if (od != null && od.trim().length > 0) {
                    now = moment(od).add(2, 'hours'); // Add two hours to get around the edge of isBetween()
                    console.log("Overriding the LTO now() date. Setting it to", now)
                }
                const or = urlParams.get('override_lto_region')
                if (or != null && or.trim().length > 0 && or.match(/^(AB|BC|MB|NB|NL|NS|NT|NU|ON|PE|QC|SK|YK)$/)) {
                    console.log("Overriding the LTO region. Setting it to", or);
                    this.state.region = or; // Not updating the actual state
                }

            }

			console.log("Region is", this.state.region);
            let video = lto.video;
            let inRegion = lto.region === 'ALL' ? true : (lto.region === this.state.region);
            
            
            // Get the latest for a region 
            if(!matchedRegion) { // if region doesnt match, do loop on map iteration
                if ( (now.isBetween(startDate, endDate) ) && inRegion ) {
                    matchedRegion = true; // if matches, we set this to true, and further loops are stopped
                    // Set title
                    let hero_title = lto.title[this.props.lang];
                    // Set path to images (this is needed for dynamic paths)
                    const media = require.context('../../../localdata', true);
                    // Set the href
                    let ltoLink = lto.link[this.props.lang];
                
                    if(!video) {
                        // Get the images
                        let mobileHero = media('.' + lto.mobile[this.props.lang]);
                        let desktopHero = media('.' + lto.desktop[this.props.lang]);
                        // Set the image
                        let heroImage = this.props.isDesktop === true ? desktopHero : mobileHero;
                        let style = {
                            backgroundImage: 'url('+heroImage+')'
                        };
                        if (ltoLink.startsWith('http') || ltoLink.startsWith('/i/')) {
                            return (
                                <a onClick={() => trackGAEvent("Home Page", "Center Block", "Variable 1")} href={ltoLink} title={hero_title} key={index} className="hero-lto" style={style}>
                                    <img src={arrow} className="bounce arrow" alt="arrow button" />
                                </a>
                            )
                        }
                        return (
                            <Link onClick={() => trackGAEvent("Home Page", "Center Block", "Variable 1")} to={ltoLink} title={hero_title} key={index} className="hero-lto" style={style}>
                                {/* <img src={heroImage} className="hero" alt="A&W Promo" />  */}
                                <img src={arrow} className="bounce arrow" alt="arrow button" />
                            </Link>
                        )
                    } else {
                        let desktopVideoHero = media('.' + lto.desktop[this.props.lang]);
                        let desktopPoster = media('.' + lto.desktopbackup[this.props.lang]);
                        let mobilePoster= media('.' + lto.mobilebackup[this.props.lang]);

                        let mobileVideoHero = media('.' + lto.mobile[this.props.lang]);

                        return (      
                            <div className={`${this.props.isDesktop ? 'desktop' : 'mobile'} vid-container`} key={index}>
                                <Link onClick={() => trackGAEvent("Home Page", "Center Block", "Variable 1")} to={ltoLink} title={hero_title}  className="hero">
                                    <video id="video-bg" poster={this.props.isDesktop ? desktopPoster : mobilePoster} className="intro-bg-video" autoPlay playsInline muted loop>
                                        <source src={this.props.isDesktop ? desktopVideoHero : mobileVideoHero} type="video/mp4"></source>
                                    </video>
                                    <img src={arrow} className="bounce arrow" alt="arrow button" />
                                </Link>
                            </div>

                        )
                    }
            
                } else {
                    // Default LTO.. aka check out the menu page
                    return false
                }

            }
            return null;
        })

        // var temp = [];
        // for(let i of imgHeroLTO) i && temp.push(i); // copy each non-empty value to 'temp' array
        // imgHeroLTO = temp;
        //console.log('imghero:', imgHeroLTO );
        return imgHeroLTO;

        //return imgHeroLTO[0]; // return only one matching region entry. this works since 'ALL' lto entry is last in position due to .reverse() on the ltoJson state

    }

    render() {
        return (
            <React.Fragment>
                {this.findActiveLTO()}
            </React.Fragment>
            
        );
    }
}

export default HeroLTO;